import { AxiosResponse } from 'axios';
import api from '../../app/axios';

export const fetchStatus = (): Promise<AxiosResponse> => {
  return api.get('/misc/healthcheck');
};
